// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';

let limit = config.limit.default;
// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getMoreToExploreCollectionError = error => {
  return {
    type: constants.GET_MORETOEXPLORECOLLECTION_ERROR,
    error,
  };
};

const getMoreToExploreCollectionSuccess = moreToExploreCollection => {
  return {
    type: constants.GET_MORETOEXPLORECOLLECTION_SUCCESS,
    moreToExploreCollection: moreToExploreCollection,
  };
};

const getMoreToExploreError = error => {
  return {
    type: constants.GET_MORETOEXPLORE_ERROR,
    error,
  };
};

const getMoreToExploreSuccess = moreToExplore => {
  return {
    type: constants.GET_MORETOEXPLORE_SUCCESS,
    moreToExplore: moreToExplore,
  };
};

const postMoreToExploreError = error => {
  return {
    type: constants.POST_MORETOEXPLORE_ERROR,
    error,
  };
};

const postMoreToExploreSuccess = moreToExplore => {
  return {
    type: constants.POST_MORETOEXPLORE_SUCCESS,
    moreToExplore: moreToExplore,
  };
};

const patchMoreToExploreError = error => {
  return {
    type: constants.PATCH_MORETOEXPLORE_ERROR,
    error,
  };
};

const patchMoreToExploreSuccess = moreToExplore => {
  return {
    type: constants.PATCH_MORETOEXPLORE_SUCCESS,
    moreToExplore: moreToExplore,
  };
};

const getMoreToExploreCollection = filterParams => {
  let apiURL = `${experienceAPIURL}/moreToExploreCollection?limit=${limit}`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1); // Remove extra & from the filter string
  }

  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getMoreToExploreCollectionError(response.statusText));
        }
        dispatch(getMoreToExploreCollectionSuccess(response.data));
      })
      .catch(error => {
        dispatch(getMoreToExploreCollectionError(error));
      });
  };
};

const getMoreToExplore = id => {
  let apiURL = `${experienceAPIURL}/moreToExploreCollection/${id}`;

  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getMoreToExploreError(response.statusText));
        }
        dispatch(getMoreToExploreSuccess(response.data));
      })
      .catch(error => {
        dispatch(getMoreToExploreError(error));
      });
  };
};

const postMoreToExplore = newMoreToExplore => {
  let apiURL = `${experienceAPIURL}/moreToExploreCollection`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST', data: newMoreToExplore };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(postMoreToExploreError(response.statusText));
        }
        dispatch(postMoreToExploreSuccess(response.data));
      })
      .catch(error => {
        dispatch(postMoreToExploreError(error));
      });
  };
};

const patchMoreToExplore = moreToExplore => {
  let apiURL = `${experienceAPIURL}/moreToExploreCollection/${moreToExplore.id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'PATCH', data: moreToExplore };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(patchMoreToExploreError(response.statusText));
        }
        dispatch(patchMoreToExploreSuccess(response.data));
      })
      .catch(error => {
        dispatch(patchMoreToExploreError(error));
      });
  };
};

export { getMoreToExploreCollection, getMoreToExplore, postMoreToExplore, patchMoreToExplore };
